const OverwritePolicy = {
  ALLOW: 'ALLOW',
  PROHIBIT: 'PROHIBIT',
  WARN: 'WARN'
};
export default OverwritePolicy;